<template>
  <div>
    <DropdownSubItem
      label="Seller"
      :options="sellers"
      :selected-options="selectedOptions"
      :loading="isLoadingSellers"
      @on-apply="onApply"
    >
      <template #footer>
        <LoadMoreData
          v-show="hasMoreSellers"
          :fetcher="sellersFetcher"
        />
      </template>
    </DropdownSubItem>
  </div>
</template>

<script>
import LoadMoreData from '../non-komship/LoadMoreData.vue'
import DropdownSubItem from './DropdownSubItem.vue'

export default {
  name: 'FilterSeller',
  components: {
    DropdownSubItem,
    LoadMoreData,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    selectedOptions: {
      type: Array,
      default: () => [],
    },
    sellersFetcher: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      sellerOptions: [],
    }
  },
  computed: {
    sellers() {
      return this.sellersFetcher?.data.map(item => ({
        label: item.shop_name,
        value: item.shop_id,
      }))
    },
    isLoadingSellers() {
      return this.sellersFetcher?.isLoading && this.sellersFetcher?.data.length === 0
    },
    hasMoreSellers() {
      return this.sellersFetcher?.hasMore || false
    },
  },
  watch: {
    active(newVal) {
      if (this.sellersFetcher && this.sellersFetcher.data.length < 1 && newVal) {
        this.sellersFetcher.fetchData({ reset: true })
      }
    },
  },
  methods: {
    onApply(checkedOptions) {
      this.$emit('on-apply', { checkedOptions, label: 'seller' })
    },
  },
}
</script>
